import React, {useEffect, useMemo, useState} from 'react';
import {EmailReportingProps} from "./EmailReporting.props";
import {Box, Stack, Typography } from "@mui/material";
import './EmailReporting.css';
import {DataTables} from "../DataTables";
import {GridColDef, GridRenderCellParams} from "@mui/x-data-grid";
import {formatNumber, getCurrentCellStore, getUserName} from "../../utils/util";
import {UserAvatarLetters} from "../UserAvatarLetters";
import {images} from "../../constants/images";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import {
  getEmailReportingListEvents,
  getEmailReportingListEventsDataSelector,
  removeEmailReporting,
  IDataEmailReporting,
  IDataEmailReportingList,
  IGroupEmailReportingList
} from "../../redux/getEmailReportingListSilce";
import {LoadingPage} from "../LoadingPage";
import {CustomChip} from "../CustomChip";

interface emailReportingRow extends IDataEmailReportingList {
  id: number;
}
interface groupEmailReportingRow extends IGroupEmailReportingList {
  id: number;
}

const EmailReporting : React.FC<EmailReportingProps> = ({cellId,isAttribute = false}) => {
  const [emailReportingRows, setEmailReportingRows] = useState<emailReportingRow[] | groupEmailReportingRow[] >([]);
  const [totalRows, setTotalRows] = useState(0);
  const { dataEmailReporting, isLoading } = useAppSelector(getEmailReportingListEventsDataSelector);
  const userCurrentCellStore = getCurrentCellStore();
  const dispatch = useAppDispatch();
  const [selectedRow, setSelectedRow] = useState<any[]>([]);

  const DEFAULT_PARAMS = {
    cell_id:cellId,
    offset_rankings: 1,
    offset_groups: 1,
    limit_rankings: 10,
    limit_groups: 10
  };

  const columns: GridColDef[] = useMemo(() => {
    const baseColumns: GridColDef[] = [
      {
        field: 'rank',
        headerName: '',
        sortable: false,
        width:20,
        align: "center",
        headerClassName: 'data-table-header-cell',
        renderCell: (params: GridRenderCellParams) => {
          return <p>#{params.row.rank}</p>;
        }
      },
      {
        field: 'learner_email',
        headerName: 'Learners',
        flex: 5,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => {
         return <Box
            sx={{
              display: "flex",
              alignItems: "center",
              minHeight: '68px'
            }}
          >
           {getUserName(params.row) ? (
             <UserAvatarLetters classNames={'avatar-list-email-reporting'} name={getUserName(params.row)} />
           ) : (
             <div className="profile-avatar">
               <img className="profile-picture" src={images.NoAvatar} alt="avatar" />
             </div>
           )}
            <Stack
              sx={{ ml: '10px', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
              <Typography className={'name-cell row-selected'}>
                {params.row.first_name} {params.row.last_name}
              </Typography>
              {params.row.learner_id ===  userCurrentCellStore?.student_id && (
                <CustomChip
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        fontFamily: 'Montserrat',
                        fontSize: 14
                      }}>
                      Your Position
                      <AccountCircleIcon sx={{ fontSize: 24, color: '#193051' }} />
                    </Box>
                  }
                  className={`custom-chip position btn-your-position`}
                />
              )}
            </Stack>
          </Box>
        }
      },
      {
        field: 'total_points',
        headerName: 'Total points',
        sortable: false,
        flex: 2,
        align: 'right',
        headerClassName: 'header-sort-right',
        sortingOrder: ['asc', 'desc'],
        renderCell: (params: GridRenderCellParams) => (
          formatNumber(params.value)
        )
      }];
    if (isAttribute) {
      return [
        {
          field: 'rank',
          headerName: '',
          sortable: false,
          width:20,
          align: "center",
          headerClassName: 'data-table-header-cell',
          renderCell: (params: GridRenderCellParams) => {
            return <p>#{params.row.rank}</p>;
          }
        },
        {
          field: 'group',
          headerName: 'Group',
          flex: 4,
          sortable: false,
          renderCell: (params: GridRenderCellParams) => {
            return <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  minHeight: '68px'
                }}
            >
              {(params && params.value) ? (
                  <UserAvatarLetters classNames={'avatar-list-email-reporting'} name={params.value} />
                  ) : (
                  <div className="profile-avatar">
                    <img className="profile-picture" src={images.NoAvatar} alt="avatar" />
                  </div>
              )}
              <Stack sx={{ ml: '10px', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                <Typography className={'name-cell row-selected'}>
                  {params.value}
                </Typography>
                {params.row.has_group && (
                  <CustomChip
                    label={
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          fontFamily: 'Montserrat',
                          fontSize: 14
                        }}>
                        Your Group
                        <AccountCircleIcon sx={{ fontSize: 24, color: '#193051' }} />
                      </Box>
                    }
                    className={`custom-chip position btn-your-group`}
                  />
                )}
              </Stack>
            </Box>
          }
        },
        {
          field: 'average_points',
          headerName: 'Average Points',
          sortable: false,
          flex: 2,
          align: 'right',
          headerClassName: 'header-sort-right',
          sortingOrder: ['asc', 'desc'],
          renderCell: (params: GridRenderCellParams) => (
              formatNumber(params.value)
          )
        }
      ];
    }

    return baseColumns;
  }, [isAttribute]);

  const removeEmailReportingData = async () => {
    await dispatch(
      removeEmailReporting()
    );
  };

  const getEmailReporting = async (params: any) => {
    await dispatch(
        getEmailReportingListEvents(params)
      );
  };

  const handleRowsTable = (data:IDataEmailReporting, attribute:boolean) => {
    let rows =[];
    let selectedRowIds =[];
    if(attribute) {
      rows = data.groups.data.map((learner, index) => ({
        ...learner,
        id: index
      }));
      selectedRowIds = rows
        .filter((row: groupEmailReportingRow) => row?.has_group)
        .map((row: groupEmailReportingRow) => row.id);
    } else {
      rows = data.rankings.data.map((learner, index) => ({
        ...learner,
        id: index
      }));
      selectedRowIds = rows
        .filter((row: emailReportingRow) => row?.learner_id === userCurrentCellStore?.student_id)
        .map((row: emailReportingRow) => row.id);
    }

    setSelectedRow(selectedRowIds)
    setEmailReportingRows(rows);
    setTotalRows(rows?.length);
  }

  useEffect( () => {
    getEmailReporting(DEFAULT_PARAMS);

    return () => {
      removeEmailReportingData()
    }
  }, [dispatch]);

  useEffect(() => {
    handleRowsTable(dataEmailReporting, isAttribute)
  }, [dataEmailReporting, isAttribute]);

  const fetchMoreDataEmailReporting = async (dataReporting: IDataEmailReporting) => {
    const { rankings, groups } = dataReporting;
    let params = {};
    if (!isAttribute) {
      const nextOffset = rankings?.pagination?.offset + 1;
      params = { ...DEFAULT_PARAMS, offset_rankings: nextOffset };
      if (rankings?.pagination?.has_more) {
        await getEmailReporting(params);
      }
    } else {
      const nextOffset = groups?.pagination?.offset + 1;
      params = { ...DEFAULT_PARAMS, offset_groups: nextOffset };
      if (groups?.pagination?.has_more) {
        await getEmailReporting(params);
      }
    }
  };

  return (
    <>
      <Stack
        className='email-reporting'
        id="email-reporting"
      >
        <DataTables
          tblRows={emailReportingRows}
          tblColumns={columns}
          totalRows={totalRows}
          sortingMode={'server'}
          autoHeight={false}
          rowSelectionModel={selectedRow}
          noRowsLabel={'No Data Available'}
          onTableScrollEnd={(data:IDataEmailReporting)=>fetchMoreDataEmailReporting(data)}
          tableScrollData={dataEmailReporting}
        />
      </Stack>
      <LoadingPage open={isLoading }/>
    </>
  );
};

export default EmailReporting;
